<footer class="main-footer">
  <span class="m-auto"></span>
  <span>&copy; 2020 Cuepid Inc.</span>
</footer>
